import { graphqlAjax } from '..'
import { gql } from 'apollo-boost'
import { ROLEID } from '@GUTIL/hardCode'

export default {
  /* Query */
  getAllDivisions: params => {
    const query = gql`
      query($filter: DivisionsFilterInput!) {
        allDivisions(in: $filter) {
          data {
            id
            name
            customer_services {
              username
              nickname
            }
            department {
              name
            }
            sections {
              name
            }
            creator {
              username
            }
            updater {
              username
            }
            created_at
            updated_at
          }
          meta {
            total
          }
        }
      }
    `
    return graphqlAjax('get', query, params)
  },
  getDivision: params => {
    const query = gql`
      query($id: Int!) {
        division(id: $id) {
          id
          name
          department {
            id
            name
          }
          sections {
            id
            name
          }
          customer_services {
            id
            username
            nickname
          }
          creator {
            username
          }
          updater {
            username
          }
          created_at
          updated_at
        }
      }
    `
    return graphqlAjax('get', query, params)
  },
  getDivisionSelectedOptions: () => {
    const query = gql`
      query($departmentIn: DepartmentsFilterInput!) {
        allDepartments(in: $departmentIn) {
          data {
            id
            name
          }
        }
      }
    `
    return graphqlAjax('get', query, {
      // 配置分口選項
      departmentIn: {
        base_filter: {
          page: 1,
          per_page: -1
        }
      }
    })
  },
  getSelectedOptionsByDepartment: params => {
    const query = gql`
      query($id: Int!, $filter: AccountsFilterInput) {
        department(id: $id) {
          id
          name
          divisions {
            customer_services {
              id
              username
              nickname
            }
          }
          sections {
            id
            name
          }
        }
        allAccounts(filter: $filter) {
          data {
            id
            username
            nickname
          }
        }
      }
    `
    return graphqlAjax('get', query, {
      ...params,
      filter: {
        is_department_unbinded: true,
        role_ids: [ROLEID.CUSTOMER_SERVICE],
        base_filter: {
          page: 1,
          per_page: -1
        }
      }
    })
  },

  /* Mutation */
  // [XO3.1] 新增組別
  createDivision: (params, opts = {}) => {
    const mutation = gql`
      mutation($in: CreateDivisionInput!) {
        createDivision(in: $in)
      }
    `
    return graphqlAjax('post', mutation, params, opts)
  },
  // [XO3.1] 編輯組別
  updateDivision: params => {
    const mutation = gql`
      mutation($id: Int!, $in: UpdateDivisionInput!) {
        updateDivision(id: $id, in: $in)
      }
    `
    return graphqlAjax('post', mutation, params)
  }
}
